import React,{useState} from "react";

//import components
import PaymentModal from "../../PaymentModal";
import MiniCard from "./Mini-Card";
import "./First-Card-Section.scss";

//icons
import { MdCreditScore } from "react-icons/md";
import { MdWaterDrop } from "react-icons/md";
import { FaClock } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
const FirstCardSection = ({
  paymentProgressInvoices,
  paymentProgressPayments,
}) => {

  const rent = paymentProgressInvoices?.rent;
  const garbage = paymentProgressInvoices?.garbage;
  const water = paymentProgressInvoices?.water;
  const arrears = paymentProgressInvoices?.unpaidDeposit;

  const rentPaid = paymentProgressPayments?.rent || 0;
  const garbagePaid = paymentProgressPayments?.garbage_charge || 0;
  const waterPaid = paymentProgressPayments?.water_bill || 0;
  const arrearsPaid = paymentProgressPayments?.arrears || 0;

  //modal variables
  const [isOpen, setIsOpen] = useState(false);
  const [defaultValues, setDefaultValues] = useState({
    
  });
  const openModal = () => {
    setIsOpen(true);
  }
  const closeModal = () => {
    setIsOpen(false);
  }
 
  const handlePayment = (invoiceId) => {
    // Open the modal
    setIsOpen(true);
    setDefaultValues({}); 
  };

  return (<>
    <div className="make-payment-button-container">
          <button
            className="make-payment-button"
            onClick={() => handlePayment()}
          >
            Make Payment
          </button>
    </div>
    
    <div className="mini-card-container">
      
      <MiniCard
        title="Rent Paid"
        amount={`${rentPaid}`}
        percentage={`${(rentPaid / rent) * 100}`}
        IconType={MdCreditScore}
      />
      <MiniCard
        title="Garbage Paid"
        amount={`${garbagePaid}`}
        percentage={`${(garbagePaid / garbage) * 100}`}
        setColorAlternate={true}
        IconType={FaTrash}
      />
      <MiniCard
        title="Water Paid"
        amount={`${waterPaid}`}
        percentage={`${(waterPaid / water) * 100}`}
        setMarginTop={true}
        setColorAlternate={true}
        IconType={MdWaterDrop}
      />
      <MiniCard
        title="Arrears Paid"
        amount={`${arrearsPaid}`}
        percentage={`${(arrearsPaid / arrears) * 100}`}
        setMarginTop={true}
        IconType={FaClock}
      />
    </div>

    <PaymentModal
        isOpen={isOpen}
        closeModal={closeModal}
        defaultValues={defaultValues} // Set default values here
        fieldsToShow={[
          "rent",
          "arrears",
          "water",
          "serviceCharge",
          "unpaidDeposit",
          "garbage",
        ]} // Specify which fields to show
      />
  </>
   
  );
};

export default FirstCardSection;
